module.exports = __webpack_public_path__ + "media/images/advert-img-05-372bbcd1a51e88af40f3ec5731f959fd.png";